/**
 * SF-5055 — which help desk plan lets Eva reply to help desk tickets at all. Mirrors sf-api
 * utils/helpDeskPlan.js, which is the real check. The admin PATCH refuses switching Eva on or
 * choosing either automatic level on Lite. Moving to Lite switches Eva off and resets the level to
 * manual in the same save. Mix: Eva runs only for tickets at Premium locations.
 * Missing plan = Lite (sf-api's default).
 */
import type { Company } from '../list';

/** May Eva helpdesk replies be on for a company on this plan? (Mix: Premium locations only.) */
export const evaRepliesPlanAllowed = (plan: Company['helpDeskPlan']): boolean =>
  plan === 'premium' || plan === 'mix';

export const EVA_REPLIES_NEED_PREMIUM_TEXT =
  'Eva helpdesk replies need the Premium or Mix help desk plan.';

// AUTO_SEND_NEEDS_PREMIUM is the older sf-api's code for the same plan refusal (automatic sending
// on Lite): either code gets the same line, so a server not yet updated still reads right.
const PLAN_REFUSAL_CODES = new Set(['EVA_REPLIES_NEED_PREMIUM', 'AUTO_SEND_NEEDS_PREMIUM']);

/** The line for a PATCH sf-api refused because of the plan; null for any other failure. */
export const evaRepliesPlanErrorText = (err: unknown): string | null => {
  const code = (err as { response?: { data?: { reason_code?: unknown } } } | undefined)?.response
    ?.data?.reason_code;
  return typeof code === 'string' && PLAN_REFUSAL_CODES.has(code)
    ? EVA_REPLIES_NEED_PREMIUM_TEXT
    : null;
};
